export const PROVIDERS = [
  { value: 'anthropic', label: 'Anthropic', dot: '#C96442' },
  { value: 'openai', label: 'OpenAI', dot: '#10A37F' },
  { value: 'deepseek', label: 'Deepseek', dot: '#6B5BD2' },
  { value: 'gemini', label: 'Gemini', dot: '#4285F4' },
]

export const MODELS = {
  anthropic: ['claude-opus-4-8', 'claude-sonnet-4-6', 'claude-haiku-4-5','claude-sonnet-5'],
  openai: ['gpt-4o', 'gpt-4o-mini', 'gpt-4.1'],
  deepseek: ['deepseek-chat', 'deepseek-reasoner'],
  gemini: ['gemini-2.5-pro', 'gemini-2.5-flash', 'gemini-2.5-flash-lite'],
}

export const VARIABLE_GROUPS = [
  { category: 'Client', vars: ['client_name', 'client_id', 'client_website'] },
  { category: 'Commercial', vars: ['comercial_user_first_name', 'comercial_user_last_name', 'comercial_user_id'] },
  { category: 'Prospect', vars: ['prospect_first_name', 'prospect_last_name', 'prospect_full_name', 'prospect_email', 'prospect_phone', 'prospect_title', 'prospect_company', 'prospect_industry'] },
  { category: 'Order / Campagne', vars: ['order_context', 'order_id', 'cold_call_rules', 'email_step_1', 'email_step_2', 'email_step_3'] },
  { category: 'Appel', vars: ['transcript', 'call_attempt_number', 'previous_call_outcome', 'previous_call_date'] },
  { category: 'Email', vars: ['email_history_summary', 'email_cc'] },
  { category: 'Date / Temps', vars: ['current_date', 'current_time', 'current_day_of_week'] },
  {
    category: 'Writer / Séquences',
    vars: [
      'company_name',
      'company_description',
      'product_name',
      'website_url',
      'want_to_offer',
      'target_language',
      'company_solutions_1',
      'company_solutions_2',
      'company_solutions_3',
      'company_social_1',
      'company_social_2',
      'company_social_3',
    ],
  },
]

export const LANGS = ['FR', 'EN', 'ES', 'IT']
export const DEFAULT_LANG = 'FR'

export const PROMPT_CATEGORIES = [
  {
    category: 'Aide aux account managers',
    prompts: [
      { key: 'agent_tailor_generate_prompt_to_client', name: 'Tailor', description: 'Génère le prompt de base du client pour la section Agent-AI.', allowDisabled: false },
      {
        key: 'writer',
        name: 'Writer',
        description: 'Génère les variantes de séquences d’onboarding. Prompts par type (presentation, argument_…) et langue — source: target_sequences_type. Provider/modèle/clé se configurent ici.',
        allowDisabled: true,
      },
      { key: 'agent_briefer_generate_prompt_to_cold_call', name: 'Briefer', description: "Génère le script d'appel à froid pour l'agent.", allowDisabled: false },
    ],
  },
  {
    category: 'Écoute des appels de prospection',
    prompts: [
      { key: 'resumecallprompt', name: 'Herald', description: 'Synthétise le contexte du prospect pour préparer le client.', allowDisabled: false },
      { key: 'get_transcript_call_prompt', name: 'Tagger', description: 'Catégorise les objections des appels marqués « Pas intéressé ».', allowDisabled: false },
      { key: 'agent_athena_check_call_prompt', name: 'Listener', description: "Analyse les transcripts d'appels pour décider d'un rendez-vous.", allowDisabled: true },
      { key: 'agent_athena_check_call_qualifications_prompt', name: 'Athena', description: 'Classifie chaque appel selon son issue commerciale finale.', allowDisabled: true },
      { key: 'agent_maestro_check_call_prompt', name: 'Maestro', description: 'Maestro.', allowDisabled: false },
    ],
  },
  {
    category: 'Lecture et traitement des réponses par email',
    prompts: [
      { key: 'get_tag_email_prompt', name: 'Sorter', description: "Classe les réponses prospects en catégories d'intention.", allowDisabled: false },
      { key: 'answeremailprompt', name: 'Echo', description: 'Répond automatiquement aux réponses email des prospects.', allowDisabled: false },
      { key: 'agent_athena_check_email_prompt', name: 'Reader', description: "Analyse les échanges email pour décider d'un rendez-vous.", allowDisabled: true },
    ],
  },
  {
    category: 'Aide aux bookers',
    prompts: [
      { key: 'callprompt', name: 'Scout', description: "Génère un script personnalisé par tâche d'appel.", allowDisabled: false },
      { key: 'call', name: 'Riposte', description: 'Produit des scripts de réponse aux objections téléphoniques.', allowDisabled: false },
      { key: 'daily_sintesis_prompt', name: 'Mentor', description: "Coache quotidiennement chaque booker via ses transcripts d'appels.", allowDisabled: false },
      { key: 'get_formation_prompt', name: 'Tutor', description: 'Génère une formation produit pour chaque client signé.', allowDisabled: false },
    ],
  },
  {
    category: 'Analyse Meeting effectué',
    prompts: [
      { key: 'meeting_prompt_analysis', name: 'Scribe', description: 'Analyse les meetings effectués.', allowDisabled: false },
      { key: 'meeting_prompt_coaching', name: 'Coach', description: 'Produit une analyse de coaching des meetings.', allowDisabled: false },
    ],
  },
  {
    category: 'Agents téléphoniques',
    prompts: [
      { key: 'reschedule_prompt_meeting', name: 'Relio', description: 'Traite les cas liés à la reprogrammation des réunions.', allowDisabled: true },
    ],
  },
  {
    category: 'Opérations',
    prompts: [
      { key: 'meeting_prompt_judge', name: 'Judge', description: 'Vérifie la légitimité des signalements de rendez-vous hors cible.', allowDisabled: false },
      { key: 'verifier_prompt', name: 'Verifier', description: 'Classifies meeting as valid / fake / abusive.', allowDisabled: false },
    ],
  },
]

export function promptMetaForKey(key) {
  for (const category of PROMPT_CATEGORIES) {
    const prompt = category.prompts.find(item => item.key === key)
    if (prompt) return { ...prompt, category: category.category }
  }
  return null
}

export function providerMeta(value) {
  return PROVIDERS.find(p => p.value === value) || PROVIDERS[0]
}

export function modelsFor(provider) {
  return MODELS[provider] || []
}
